/**
 * VistoeraTASK-00635 — fail-closed auth matrix error surface.
 * Shown when GET …/auth-matrix/me fails; does not imply the user has no grants.
 */
import { Alert, Button } from 'antd'
import { useSyncExternalStore } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../../AuthContext'
import {
  getAuthMatrixRevision,
  getAuthMatrixStatus,
  retryWorkspaceAuthMatrix,
  subscribeAuthMatrix,
} from './authMatrixRuntime'

export default function AuthMatrixLoadBanner({ workspaceId }: { workspaceId: string }) {
  const { t } = useTranslation('canvas')
  const { me } = useAuth()
  useSyncExternalStore(subscribeAuthMatrix, getAuthMatrixRevision, getAuthMatrixRevision)
  const status = getAuthMatrixStatus()
  if (status !== 'error') return null
  return (
    <Alert
      type="warning"
      showIcon
      style={{ margin: '8px 12px 0', borderRadius: 8 }}
      data-testid="canvas-auth-matrix-load-error"
      message={t('chrome.library.authLoadFailed')}
      action={
        <Button
          size="small"
          type="primary"
          data-testid="canvas-auth-matrix-retry"
          onClick={() => void retryWorkspaceAuthMatrix(workspaceId, me?.user.id)}
        >
          {t('chrome.library.authRetry')}
        </Button>
      }
    />
  )
}
